module.exports = __webpack_public_path__ + "Thumbs-up-filled.png";